import registerTaskList from '../../../common/taskLists/index';
// TODO
import presentationalComponent from './TaskListPresentationalWrapper';
import containerComponent from './TaskListContainer';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';
import { TASK_TYPE } from '../../../common/tasks/tasksConstants';

export default () => {
    const isEditingTask = (hasEditorSelection, editorKey) => hasEditorSelection && editorKey === TASK_TYPE;

    return registerTaskList({
        containerComponent,
        presentationalComponent,
        tools: [
            TOOLS.ASSIGNMENT,
            TOOLS.TASK_RICH_TEXT,
            {
                ...TOOLS.COLOR,
                predicate: (element, selectedElements, currentUser, hasEditorSelection, editorKey) =>
                    !isEditingTask(hasEditorSelection, editorKey),
            },
            TOOLS.TASK_COLOR,
            {
                ...TOOLS.TITLE,
                predicate: (element, selectedElements, currentUser, hasEditorSelection, editorKey) =>
                    !isEditingTask(hasEditorSelection, editorKey),
            },
        ],
    });
};
